import _extends from "@babel/runtime/helpers/extends";
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b982181fbff74febc09fce21faab976>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconFacade } from '@atlaskit/icon/base';
var Epic24Icon = function Epic24Icon(props) {
  return /*#__PURE__*/React.createElement(IconFacade, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" role=\"presentation\"><path fill=\"#6554c0\" fill-rule=\"evenodd\" d=\"M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m15.188 9.4h-3.063V4.8a1.807 1.807 0 0 0-3.16-1.192l-.197.21c-.095.114-.095.114-.324.397a678 678 0 0 0-2.976 3.699l-.093.117C5.188 12.03 5 12.274 5 12.8c0 1.01.819 1.599 1.77 1.76l.168.014h2.937V19.2c0 .997.815 1.8 1.813 1.8.43 0 .963-.236 1.52-.793l.073-.083.28-.35a1306 1306 0 0 0 2.973-3.744l.049-.061a403 403 0 0 0 2.21-2.815q.474-.612.734-.96.142-.19.223-.306c.042-.062.042-.062.085-.13.05-.046.05-.046.165-.558 0-.997-.815-1.8-1.812-1.8m-5.063 2V5.317l-.863 1.066a627 627 0 0 0-2.23 2.778l-.047.058-.046.059c-1.573 1.973-2.217 2.788-2.596 3.296h4.532v6.106l.122-.154a1305 1305 0 0 0 2.969-3.736l.048-.061A400 400 0 0 0 17.62 11.4z\"/></svg>"
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    size: "medium"
  }));
};
Epic24Icon.displayName = 'Epic24Icon';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Epic24Icon;